
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lookbook",
      function () {
        return require("private-next-pages/lookbook/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lookbook"])
      });
    }
  